import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import AboutMeSec from './aboutMeSec'
import BoxesSec from './boxesSec'
import InfoList from './infoList'
import CoustomerComments from './coustomerComments'
import CilentSec from './cilentsSec'
import { getCvErrors, getCvStatus, selectAllInfoMe, selectContactUsInfo } from '../../reducers/resumeSlice'
import { fetchadminInfo } from '../../reducers/resumeSlice';
import LoaderCoustomerComments from './loaderCoustomerComments';
import LoaderCilentSec from './LoaderCilentSec';
import LoaderBoxesSec from './LoderBoxesSec';
import LoaderAboutMeSec from './LoaderAboutMeSec';
import LoaderInfoList from './LoaderInfoList';

// import { CustomAxios } from '../../widgets/CustomAxios'

export default function AboutMe() {
    const dispatch = useDispatch();

    const selector = useSelector((state) => state.infoMe)

    // dispatch(fetchadminInfo())

    const cvInfo = useSelector(selectAllInfoMe)
    const cvInfo2 = useSelector(getCvStatus)

    // console.log("status")
    // console.log(cvInfo2);
    // console.log(cvInfo);
    // const error = useSelector(getCvErrors)
    // const cvStatus = useSelector(getCvStatus)

    return (
        <>
            <section data-id="about-me" className="animated-section about-me section-active">
                <div className="section-content">

                    {cvInfo !== null ? <AboutMeSec cvInfo={cvInfo.admin} /> : <LoaderAboutMeSec />}

                    {cvInfo !== null ? <BoxesSec boxInfo={cvInfo.boxes} /> : <LoaderBoxesSec />}

                    {cvInfo !== null ? <InfoList listIn={cvInfo.infoList} /> : <LoaderInfoList />}

                    {cvInfo !== null ? <CoustomerComments customerCm={cvInfo.customerComments} /> : <LoaderCoustomerComments />}

                    {cvInfo !== null ? <CilentSec cilentsList={cvInfo.cilents} /> : <LoaderCilentSec />}

                    {/* <PricingSec /> */}
                </div>
            </section>
        </>
    )
}
